import styles from "../../ProductsRPDesigner.module.scss";
import { Slider } from "@mui/material";
import { sliderElements } from "../../responsePage/rptemplate";

function GSGaps({ gaps, changeGap }) {
  const sliders = [
    sliderElements.find((se) => se.name === "gapTop"),
    sliderElements.find((se) => se.name === "gapBottom"),
    sliderElements.find((se) => se.name === "gapLeft"),
    sliderElements.find((se) => se.name === "gapRight"),
  ];

  return (
    <div
      data-tour="rpdesigner-step-1"
      className={styles["sec--products--rpdesigner--colors"]}
    >
      {sliders.map((el) => {
        if (gaps?.[el.name] !== undefined) {
          return (
            <div
              key={el.name}
              className={styles["sec--products--rpdesigner--colors--element"]}
            >
              <div
                className={
                  styles["sec--products--rpdesigner--colors--element--left"]
                }
              >
                {el.label}
              </div>
              <div style={{ width: "80px" }}>
                <Slider
                  id={el.name}
                  data-testid={el.name}
                  size="small"
                  defaultValue={el.defaultValue}
                  value={gaps?.[el.name].value}
                  min={el.minValue}
                  max={el.maxValue}
                  aria-label="Small"
                  valueLabelDisplay="auto"
                  onChange={(e, newValue) => changeGap(newValue, el.name)}
                />
              </div>
            </div>
          );
        }
      })}
    </div>
  );
}

export default GSGaps;
